import { GET_STORIES_REQUESTS_REQUEST,
  GET_STORIES_REQUESTS_SUCCESS,
  GET_STORIES_REQUESTS_FAILED } from '../../actions/stories/stories';

const initialState = {
  requesting: false,
  requestedStories: [],
  completed: false,
  error: null
}

export const storyRequests = (state = initialState, action) => {

  switch (action.type) {

    case GET_STORIES_REQUESTS_REQUEST:
      return Object.assign({}, state, {
        requesting: true,
        error: null
      });
    case GET_STORIES_REQUESTS_SUCCESS:
      return Object.assign({}, state, {
        requesting: false,
        requestedStories: action.payload.data.payload,
        completed: true
      })
    case GET_STORIES_REQUESTS_FAILED:
      return Object.assign({}, state, {
        requesting: false,
        requestedStories: action.payload.data.payload,
        completed: true
      })

    default:
      return state;
  }

}



// WEBPACK FOOTER //
// ./src/redux/reducers/stories/storyRequests.js